export default "__VITE_ASSET__BihWQhds__"